
/**
 * Implement the handlers
 * */
export class HandlerBase {
    //#region Attributes

    _labels = []

    //#endregion

    //#region Constructors

    constructor() {
        if (this.constructor === HandlerBase) {
            throw new Error("Object of Abstract Class cannot be created");
        }
    }

    //#endregion

    //#region Methods

    init() {
        this._throwNoImplementError();
    }

    _throwNoImplementError() {
        throw new Error("Method not implement");
    }

    /**
     * 
     * @param {boolean} loading
     * @param {string | HTMLElement} target 
     * */
    _loading(loading, target) {
        kendo.ui.progress($(target), loading);
    }

    /**
     * 
     * @param {string} string
     * @param {Array} params
     * @returns {string}
     */
    _format(string, params) {
        if (string === "") {
            return ""
        }

        return string.replace(/{(\d+)}/g, (match, index) => {
            return typeof params[index] !== "undefined" ? params[index] : match;
        });
    }

    /**
     * Valid if the navigation is from a mobile device
     * @returns {boolean}
     */
    _isMobile() {
        return /Mobi|Android/i.test(navigator.userAgent);
    }

    /**
     * Validate email format
     * @param {string} email
     * @returns {boolean}
     */
    _validateEmailFormat(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    /**
     * Merge labels to the label collection
     * @param {Array<string>} labels
     */
    _setLocationResources(labels) {
        if (labels.length > 0) {
            this._labels = this._labels.concat(labels)
        }
    }

    //#endregion

    //#region Properties

    get _businessModel() {
        return $("#BusinessModelReferenceCode").data("kendoDropDownList")
    }

    //#endregion
}